import { apiClient } from '@/services/ApiClient.js'

export class PostService {
  getPosts(query) {
    return apiClient
      .get('posts', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getPost(post) {
    return apiClient
      .get('posts/' + post)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  createPost(post) {
    return apiClient
      .post('posts', post)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  updatePost(id, post) {
    return apiClient
      .patch('posts/' + id, post)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  deletePost(id) {
    return apiClient
      .delete('posts/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
